import styled from 'styled-components'
import { space, border} from 'styled-system'

export const FormGroupWrap = styled.div `
    ${space}
    ${border}
    position: relative;
`;